import { render, staticRenderFns } from "./editPrivilegeGroup.vue?vue&type=template&id=46f04ee8&scoped=true"
import script from "./editPrivilegeGroup.vue?vue&type=script&lang=js"
export * from "./editPrivilegeGroup.vue?vue&type=script&lang=js"
import style0 from "./editPrivilegeGroup.vue?vue&type=style&index=0&id=46f04ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f04ee8",
  null
  
)

export default component.exports